/* Auto-generated from tiling-schemas.proto */
export var Tiling;
(function (Tiling) {
    /**
     * Type of tile.
     * Potential future types: ink, video, table etc.
     */
    let TileType;
    (function (TileType) {
        TileType[TileType["Unknown"] = 0] = "Unknown";
        TileType[TileType["Text"] = 1] = "Text";
        TileType[TileType["Slide"] = 2] = "Slide";
    })(TileType = Tiling.TileType || (Tiling.TileType = {}));
    /**
     * Type of text tile.
     */
    let TextTileType;
    (function (TextTileType) {
        TextTileType[TextTileType["Generic"] = 0] = "Generic";
        TextTileType[TextTileType["Title"] = 1] = "Title";
        TextTileType[TextTileType["SmartArt"] = 2] = "SmartArt";
        TextTileType[TextTileType["TableCell"] = 3] = "TableCell";
        TextTileType[TextTileType["TextBox"] = 4] = "TextBox";
        TextTileType[TextTileType["Notes"] = 5] = "Notes";
    })(TextTileType = Tiling.TextTileType || (Tiling.TextTileType = {}));
    /**
     * Text unit of a text tile element.
     */
    let TextTileElementUnit;
    (function (TextTileElementUnit) {
        TextTileElementUnit[TextTileElementUnit["Undefined"] = 0] = "Undefined";
        TextTileElementUnit[TextTileElementUnit["Word"] = 1] = "Word";
        TextTileElementUnit[TextTileElementUnit["Phrase"] = 2] = "Phrase";
        TextTileElementUnit[TextTileElementUnit["Sentence"] = 3] = "Sentence";
        TextTileElementUnit[TextTileElementUnit["Paragraph"] = 4] = "Paragraph";
    })(TextTileElementUnit = Tiling.TextTileElementUnit || (Tiling.TextTileElementUnit = {}));
    /**
     * Types of list.
     */
    let ListType;
    (function (ListType) {
        ListType[ListType["Undefined"] = 0] = "Undefined";
        ListType[ListType["Bullet"] = 1] = "Bullet";
        ListType[ListType["Numbered"] = 2] = "Numbered";
    })(ListType = Tiling.ListType || (Tiling.ListType = {}));
    /**
     * Possible numerations for a numbered list.
     */
    let ListNumeration;
    (function (ListNumeration) {
        ListNumeration[ListNumeration["Undefined"] = 0] = "Undefined";
        ListNumeration[ListNumeration["AlphaLcParenBoth"] = 1] = "AlphaLcParenBoth";
        ListNumeration[ListNumeration["AlphaUcParenBoth"] = 2] = "AlphaUcParenBoth";
        ListNumeration[ListNumeration["AlphaLcParenR"] = 3] = "AlphaLcParenR";
        ListNumeration[ListNumeration["AlphaUcParenR"] = 4] = "AlphaUcParenR";
        ListNumeration[ListNumeration["AlphaLcPeriod"] = 5] = "AlphaLcPeriod";
        ListNumeration[ListNumeration["AlphaUcPeriod"] = 6] = "AlphaUcPeriod";
        ListNumeration[ListNumeration["ArabicParenBoth"] = 7] = "ArabicParenBoth";
        ListNumeration[ListNumeration["ArabicParenR"] = 8] = "ArabicParenR";
        ListNumeration[ListNumeration["ArabicPeriod"] = 9] = "ArabicPeriod";
        ListNumeration[ListNumeration["ArabicPlain"] = 10] = "ArabicPlain";
        ListNumeration[ListNumeration["RomanLcParenBoth"] = 11] = "RomanLcParenBoth";
        ListNumeration[ListNumeration["RomanUcParenBoth"] = 12] = "RomanUcParenBoth";
        ListNumeration[ListNumeration["RomanLcParenR"] = 13] = "RomanLcParenR";
        ListNumeration[ListNumeration["RomanUcParenR"] = 14] = "RomanUcParenR";
        ListNumeration[ListNumeration["RomanLcPeriod"] = 15] = "RomanLcPeriod";
        ListNumeration[ListNumeration["RomanUcPeriod"] = 16] = "RomanUcPeriod";
        ListNumeration[ListNumeration["CircleNumDbPlain"] = 17] = "CircleNumDbPlain";
        ListNumeration[ListNumeration["CircleNumWdBlackPlain"] = 18] = "CircleNumWdBlackPlain";
        ListNumeration[ListNumeration["CircleNumWdWhitePlain"] = 19] = "CircleNumWdWhitePlain";
        ListNumeration[ListNumeration["ArabicDbPeriod"] = 20] = "ArabicDbPeriod";
        ListNumeration[ListNumeration["ArabicDbPlain"] = 21] = "ArabicDbPlain";
        ListNumeration[ListNumeration["Ea1ChsPeriod"] = 22] = "Ea1ChsPeriod";
        ListNumeration[ListNumeration["Ea1ChsPlain"] = 23] = "Ea1ChsPlain";
        ListNumeration[ListNumeration["Ea1ChtPeriod"] = 24] = "Ea1ChtPeriod";
        ListNumeration[ListNumeration["Ea1ChtPlain"] = 25] = "Ea1ChtPlain";
        ListNumeration[ListNumeration["Ea1JpnChsDbPeriod"] = 26] = "Ea1JpnChsDbPeriod";
        ListNumeration[ListNumeration["Ea1JpnKorPlain"] = 27] = "Ea1JpnKorPlain";
        ListNumeration[ListNumeration["Ea1JpnKorPeriod"] = 28] = "Ea1JpnKorPeriod";
        ListNumeration[ListNumeration["Arabic1Minus"] = 29] = "Arabic1Minus";
        ListNumeration[ListNumeration["Arabic2Minus"] = 30] = "Arabic2Minus";
        ListNumeration[ListNumeration["Hebrew2Minus"] = 31] = "Hebrew2Minus";
        ListNumeration[ListNumeration["ThaiAlphaPeriod"] = 32] = "ThaiAlphaPeriod";
        ListNumeration[ListNumeration["ThaiAlphaParenR"] = 33] = "ThaiAlphaParenR";
        ListNumeration[ListNumeration["ThaiAlphaParenBoth"] = 34] = "ThaiAlphaParenBoth";
        ListNumeration[ListNumeration["ThaiNumPeriod"] = 35] = "ThaiNumPeriod";
        ListNumeration[ListNumeration["ThaiNumParenR"] = 36] = "ThaiNumParenR";
        ListNumeration[ListNumeration["ThaiNumParenBoth"] = 37] = "ThaiNumParenBoth";
        ListNumeration[ListNumeration["HindiAlphaPeriod"] = 38] = "HindiAlphaPeriod";
        ListNumeration[ListNumeration["HindiNumPeriod"] = 39] = "HindiNumPeriod";
        ListNumeration[ListNumeration["HindiNumParenR"] = 40] = "HindiNumParenR";
        ListNumeration[ListNumeration["HindiAlpha1Period"] = 41] = "HindiAlpha1Period";
    })(ListNumeration = Tiling.ListNumeration || (Tiling.ListNumeration = {}));
    /**
     * Text tile event type corresponding to OnTileDeleted, OnTileAdded,
     * and OnTileChanged.
     */
    let TextTileEventType;
    (function (TextTileEventType) {
        TextTileEventType[TextTileEventType["Undefined"] = 0] = "Undefined";
        TextTileEventType[TextTileEventType["Delete"] = 1] = "Delete";
        TextTileEventType[TextTileEventType["Add"] = 2] = "Add";
        TextTileEventType[TextTileEventType["Change"] = 3] = "Change";
        TextTileEventType[TextTileEventType["Refresh"] = 4] = "Refresh";
    })(TextTileEventType = Tiling.TextTileEventType || (Tiling.TextTileEventType = {}));
})(Tiling || (Tiling = {}));
//# sourceMappingURL=tiling-schemas.js.map